import { type RtkQueryLayers } from '../../core';
import { userManageableFeatures } from './userManageableFeatures.og';

export const userManageableFeaturesRTKSlice: RtkQueryLayers = {
  reducers: {
    [userManageableFeatures.reducerPath]: userManageableFeatures.reducer,
  },
  middlewares: [userManageableFeatures.middleware],
};
